import { DocumentLine } from "api";
import Ajv, { JSONSchemaType, ValidateFunction } from "ajv";

/* IsDraft and DocEntry are required to map data to the correct record. */
type DocumentLineProps = Required<Pick<DocumentLine, "IsDraft" | "DocEntry">>;
/* DocumentLines property with a single entry with those properties is also required. */
type DocEntryUpdateRequiredValues = DocumentLineProps & {
  DocumentLines: DocumentLineProps[];
};

const docEntryUpdateRequiredSchema: JSONSchemaType<DocEntryUpdateRequiredValues> =
  {
    type: "object",
    properties: {
      IsDraft: { type: "boolean" },
      DocEntry: { type: "number" },
      DocumentLines: {
        type: "array",
        items: {
          type: "object",
          properties: {
            IsDraft: { type: "boolean" },
            DocEntry: { type: "number" },
          },
          required: ["IsDraft", "DocEntry"],
          additionalProperties: false,
        },
        maxItems: 1,
        minItems: 1,
      },
    },
    required: ["IsDraft", "DocEntry", "DocumentLines"],
    additionalProperties: false,
  };

export const createDocEntryUpdateRequestValues = <T>(
  docEntry: number,
  isDraft: boolean,
  values: T
): T & DocEntryUpdateRequiredValues => ({
  ...values,
  IsDraft: isDraft,
  DocEntry: docEntry,
  DocumentLines: [
    {
      IsDraft: isDraft,
      DocEntry: docEntry,
    },
  ],
});

export function validateUpdateData<T>(
  schema: JSONSchemaType<T>,
  date: T
): [boolean, ValidateFunction<T>] {
  const ajv = new Ajv();

  // Merge pass in schema's properties with the required docEntryUpdateRequiredSchema properties.
  schema.properties = {
    ...schema.properties,
    ...docEntryUpdateRequiredSchema.properties,
  };
  const validate = ajv.compile(schema);

  return [validate(date), validate];
}
